import IService from "./service";

export default class ReplyService extends IService {

    async getReply(replyId) {
        return await this.$services.api.get('consumers/forms/' + replyId);
    }
}